var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page page--inner"},[_c('mainBlock',{attrs:{"type":'reset'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }